export default __webpack_public_path__ + "static/media/clock.f73a2866.png";